export const mensagensErroGerenciarEmplacamentos = [
  "Erro ao finalizar processo.",
  "Erro ao gerar processo.",
  "Não foi possível realizar a operação",
  "Erro ao gerar Danfe a partir do XML.",
  "Escolha de placa não pode ser vazia",
  "Código de barras nulo",
  "IPVA já consultado",
  "PRIMEIRO EMPLACAM. P/ VEICULO INACABADO - BIN. (1057)",
  "Etapa já finalizada. Não é possível finalizar novamente.",
  "EXISTE RESTRICAO ATIVA QUE IMPEDE A REALIZACAO DA TRANSACAO. (4282)",
  "Selecione um processo",
  "AVISO: REGISTRO EM ATUALIZAÇÃO. AGUARDE ALGUNS MINUTOS E TENTE NOVAMENTE. (3158)",
  "PLACA JA RESERVADA PARA OUTRO PROCESSO, SELECIONE OUTRA PLACA. (3052)",
  "ERRO: ERRO DE EXECUÇÃO DAS FUNÇÕES NATURAL. CÓDIGO: 3145 PROGRAMA: IVA9R058 LINHA: 1700 (0) (5006)",
  "Falha ao fazer a consulta",
  "Não possivel buscar proxy",
  "CHASSI NÃO POSSUI PRÉ-CADASTRO NA BIN. (3000)",
  "Aviso: Evento inesperado. Entre em contato com o Help Desk.",
  "Não foi possível encontrar o código de barras.",
  "Código de marca não foi encontrado!",
  "Não foi possível executar esta etapa.",
];
